import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Logo } from '@concretecode/ui-pure';
import { appVersion } from '@concretecode/data';

@Component({
  selector: 'app-footer',
  imports: [Logo],
  templateUrl: './footer.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Footer {
  protected readonly year = new Date().getFullYear();
  protected readonly version = appVersion;
}
